import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { prettyFloatMoney } from '@/helpers/utils';
import { ACCOUNT_TYPES } from '@/helpers/constants';
import s from './index.module.scss';

export const DesktopView = ({ type, data }) => {
  const { t } = useTranslation('activity');

  if (type === ACCOUNT_TYPES.personal) {
    return (
      <div className={s.content}>
        <div className={s.row}>
          <div className="f-small-accent">{t('tax_data.sale_proceeds')}</div>
          <div className="f-small-regular">
            {prettyFloatMoney(data?.sale_proceeds, { decimalPlaces: 2 })}
          </div>
        </div>
        <div className={s.row}>
          <div className="f-small-accent">{t('tax_data.fees')}</div>
          <div className="f-small-regular">
            {prettyFloatMoney(data?.fees, { decimalPlaces: 2 })}
          </div>
        </div>
        <div className={s.row}>
          <div className="f-small-accent">{t('tax_data.net_proceeds')}</div>
          <div className="f-small-regular">
            {prettyFloatMoney(data?.net_proceeds, {
              decimalPlaces: 2,
            })}
          </div>
        </div>
        {data?.notes_text && (
          <div className={s.row}>
            <div className="f-small-accent">{t('tax_data.note')}</div>
            <div
              className={classnames(s.note, 'f-small-regular')}
              dangerouslySetInnerHTML={{ __html: data?.notes_text }}
            />
          </div>
        )}
      </div>
    );
  }

  if (type === ACCOUNT_TYPES.business) {
    return (
      <div className={s.content}>
        <div className={s.row}>
          <div className="f-small-accent">{t('tax_data.interest_expense')}</div>
          <div className="f-small-regular">
            {prettyFloatMoney(data?.interest_expense, { decimalPlaces: 2 })}
          </div>
        </div>
        <div className={s.row}>
          <div className="f-small-accent">{t('tax_data.platform_fees')}</div>
          <div className="f-small-regular">
            {prettyFloatMoney(data?.platform_fees, { decimalPlaces: 2 })}
          </div>
        </div>
        <div className={s.row}>
          <div className="f-small-accent">{t('tax_data.vat')}</div>
          <div className="f-small-regular">
            {prettyFloatMoney(data?.vat, {
              decimalPlaces: 2,
            })}
          </div>
        </div>
      </div>
    );
  }

  return null;
};
